import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1691650158653'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='8111'
    >
        <path
            d='M929.875 479.4 173.15 479.4l307.8125-307.9625c11.625-11.6875 11.375-30.775-0.5625-42.75-11.9375-11.9375-31.125-12.1875-42.75-0.5375L79.775 486.25C77.75 487.9 76 489.775 74.5 491.9375c-4.025 5.375-6.025 11.8125-5.9 18.275-0.125 7.75 2.7125 15.4625 8.5625 21.3125l360.5 360.7125c11.625 11.625 30.8125 11.375 42.75-0.5625 11.9375-11.9375 12.1875-31.0625 0.5625-42.75L172.7125 540.625 929.875 540.625c16.5625 0 29.875-13.7125 29.875-30.65C959.75 493.0875 946.4375 479.4 929.875 479.4z'
            fill='currentColor'
            p-id='8112'
        ></path>
    </svg>
)

export const BackIcon = props => <Icon component={SVG} {...props} />
